import { get, isEmpty } from "lodash";
import { SOURCE_CATEGORY_NAME_MAPPING } from "../constants";
import {
  getNumber,
  synchronizeCollection,
  transformToMultiselectSave,
} from "../helpers";
function setSourceType(sourceType, values, fieldName, defaultValue) {
  switch (sourceType) {
    case 2: {
      return get(values, "employeeDeferralSource." + fieldName, defaultValue);
      break;
    }
    case 4: {
      return get(values, "employeeOtherSource." + fieldName, defaultValue);
      break;
    }
    case 5: {
      return get(
        values,
        "employerDiscretionarySource." + fieldName,
        defaultValue
      );
      break;
    }
    case 6: {
      return get(values, "employerMatchSource." + fieldName, defaultValue);
      break;
    }
    case 7: {
      return get(values, "employerMatchSource." + fieldName, defaultValue);
      break;
    }
    case 8: {
      return get(
        values,
        "employerDiscretionarySource." + fieldName,
        defaultValue
      );
      break;
    }
    case 9: {
      return get(values, "employerOtherSource." + fieldName, defaultValue);
      break;
    }
    default: {
      return get(values, "employerOtherSource." + fieldName, defaultValue);
      break;
    }
  }
}
export const toFormValue = (values, fields) => {
  return {
    [fields.sourceName]: get(values, "sourceName") || null,
    [fields.sourceType]: get(values, "sourceType", 1),
    [fields.sourceCategory]: get(values, "sourceCategory"),
    [fields.sourceSubCategory]: get(values, "sourceSubCategory"),
    [fields.sourceSubSubCategory]: get(values, "sourceSubSubCategory"),
    [fields.effectiveStartDate]: get(values, "effectiveStartDate", null),
    [fields.effectiveEndDate]: get(values, "effectiveEndDate", null),
    [fields.recordKeepingNumber]: get(values, "recordKeepingNumber"),
    [fields.isNewContributionAllowed]: get(
      values,
      "isNewContributionAllowed",
      false
    ),
    [fields.isDisplayToParticipantWebsite]: get(
      values,
      "isDisplayToParticipantWebsite",
      false
    ),
    [fields.isContributionManatory]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isContributionManatory",
      false
    ),
    [fields.contributionType]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "contributionType",
      0
    ),
    [fields.limitMinimumDollar]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "limitMinimumDollar",
      null
    ),
    [fields.limitMaximumDollar]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "limitMaximumDollar",
      null
    ),
    [fields.maximumDollarCompensation]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "maximumDollarCompensation",
      null
    ),
    [fields.rehireDeferralPercentage]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "rehireDeferralPercentage",
      null
    ),
    [fields.responsibleMode]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "responsibleMode",
      1
    ),
    [fields.eligiblePaymentType]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "eligiblePaymentType",
      0
    ),

    [fields.employerContributionType]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "employerContributionType",
      1
    ),
    [fields.percentageOfCompensation]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "percentageOfCompensation",
      0
    ),

    [fields.isNonPayPeriodApplicable]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isNonPayPeriodApplicable",
      1
    ),

    [fields.isIncludeDefferals]: get(
      values,
      "employerDiscretionarySource.isIncludeDefferals",
      1
    ),

    [fields.isIncludePlanCompensation]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isIncludePlanCompensation",
      1
    ),
    [fields.isLastDayRule]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isLastDayRule",
      1
    ),
    [fields.isHoursRequirement]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isHoursRequirement",
      1
    ),
    [fields.hours]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "hours",
      1
    ),
    [fields.isNormalRetirement]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isNormalRetirement",
      1
    ),
    [fields.isEarlyRetirement]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isEarlyRetirement",
      1
    ),
    [fields.isDeath]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isDeath",
      1
    ),
    [fields.isDisability]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isDisability",
      1
    ),

    [fields.periodForCalculation]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "periodForCalculation",
      0
    ),
    [fields.periodForMatchCalculation]: get(
      values,
      "employerMatchSource.periodForMatchCalculation"
    ),
    [fields.sourceOfMatch]: get(
      values,
      "employerMatchSource.sourceOfMatch",
      []
    )?.map((val) => val.sourceId),

    [fields.isSafeHarbourMatch]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isSafeHarbourMatch",
      1
    ),
    [fields.isMaximumLimitApplicable]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isMaximumLimitApplicable",
      1
    ),
    [fields.maximumDollarLimit]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "maximumDollarLimit",
      1
    ),
    [fields.safeHarbourType]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "safeHarbourType",
      0
    ),
    [fields.enhancedshMatchPercentage]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "enhancedshMatchPercentage",
      0
    ),
    [fields.uptoPercentageOfDeferral]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "uptoPercentageOfDeferral",
      0
    ),

    [fields.isCalculationSuspended]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isCalculationSuspended",
      1
    ),

    [fields.isCatchApplicable]: get(
      values,
      "employerMatchSource.isCatchApplicable",
      false
    ),
    /*[fields.isTrueUpApplicable]: get(
      values,
      "employerDiscretionarySource.isTrueUpApplicable",
      false
    ),*/
    [fields.isThresholdApplicable]:
      get(values, "employerDiscretionarySource") === null
        ? get(values, "employerMatchSource.isThresholdApplicable", true)
        : get(
            values,
            "employerDiscretionarySource.isThresholdApplicable",
            true
          ),
    [fields.isTrueUpApplicable]:
      get(values, "employerDiscretionarySource") === null
        ? get(values, "employerMatchSource.isTrueUpApplicable", false)
        : get(values, "employerDiscretionarySource.isTrueUpApplicable", false),
    [fields.safeHarbourType]:  get(values, "employerDiscretionarySource") === null
    ? get(values, "employerMatchSource.safeHarbourType", false)
    : get(values, "employerDiscretionarySource.safeHarbourType", false),
    [fields.isLastDayRuleApplicable]: get(
      values,
      "employerMatchSource.isLastDayRuleApplicable"
    ),
    [fields.employmentStatus]: get(
      values,
      "employerMatchSource.employmentStatus",
      []
    )?.map((val) => val.employmentStatusId),
    [fields.enhancedShMatchPercentage]: get(
      values,
      "enhancedShMatchPercentage"
    ),
    [fields.upToDeferralPercentage]: get(values, "upToDeferralPercentage"),
    [fields.percentageOfCalculation]: get(
      values,
      "employerMatchSource.percentageOfCalculation"
    ),
    [fields.percentageOfCompensationMatched]: get(
      values,
      "employerMatchSource.percentageOfCompensation",
      0
    ),
    [fields.isNonPayPeriodApplicable]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isNonPayPeriodApplicable",
      0
    ),
    [fields.isIncludeDefferals]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isIncludeDefferals",
      0
    ),
    [fields.isIncludePlanCompensation]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isIncludePlanCompensation",
      0
    ),
    [fields.isLastDayRule]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isLastDayRule",
      0
    ),
    [fields.isHoursRequirement]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isHoursRequirement",
      0
    ),
    [fields.hours]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "hours",
      0
    ),
    [fields.isNormalRetirement]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isNormalRetirement",
      0
    ),
    [fields.isEarlyRetirement]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isEarlyRetirement",
      0
    ),
    [fields.isDeath]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isDeath",
      0
    ),
    [fields.isDisability]: setSourceType(
      get(values, "sourceCategory"),
      values,
      "isDisability",
      0
    ),

    [fields.firstTierMatchPercent]: get(
      values,
      "employerMatchSource.firstTierMatchPercent",
      0
    ),
    [fields.secondTierMatchPercent]: get(
      values,
      "employerMatchSource.secondTierMatchPercent",
      0
    ),
    [fields.thirdTierMatchPercent]: get(
      values,
      "employerMatchSource.thirdTierMatchPercent",
      0
    ),
    [fields.firstTierCompensationMatchPercent]: get(
      values,
      "employerMatchSource.firstTierCompensationMatchPercent",
      0
    ),
    [fields.secondTierCompensationMatchPercent]: get(
      values,
      "employerMatchSource.secondTierCompensationMatchPercent",
      0
    ),
    [fields.thirdTierCompensationMatchPercent]: get(
      values,
      "employerMatchSource.thirdTierCompensationMatchPercent",
      0
    ),
    [fields.employeeGroupsApplicable]: get(values, "employeeGroupsApplicable"),
    [fields.qmacType]: get(values, "qmacType"),
    [fields.qmacType]: get(values, "qmacType"),
    [fields.qmacBefore1989]: get(values, "qmacBefore1989"),
    [fields.qnecBefore1989]: get(values, "qnecBefore1989"),
  };
};

export const toApiValue = (values, fields, formValues) => {
  const {
    isContributionManatory,
    contributionType,
    limitMaximumDollar,
    limitMinimumDollar,
    maximumDollarCompensation,
    rehireDeferralPercentage,
    responsibleMode,
    eligiblePaymentType,
    employerContributionType,
    isSafeHarbourMatch,
    isMaximumLimitApplicable,
    maximumDollarLimit,
    isCalculationSuspended,
    safeHarbourType,
    enhancedshMatchPercentage,
    uptoPercentageOfDeferral,
    isCatchApplicable,
    isThresholdApplicable,
    qmacType,
    percentageOfCompensation,
    isNonPayPeriodApplicable,
    isIncludeDefferals,
    isIncludePlanCompensation,
    isLastDayRule,
    isHoursRequirement,
    hours,
    isNormalRetirement,
    isEarlyRetirement,
    isDeath,
    isDisability,
    percentageOfCalculation,
    isTrueUpApplicable,
    firstTierMatchPercent,
    secondTierMatchPercent,
    thirdTierMatchPercent,
    firstTierCompensationMatchPercent,
    secondTierCompensationMatchPercent,
    thirdTierCompensationMatchPercent,
    sourceOfMatch,
    sourceSubCategory,
    additionalDeferralSource,
    isLastDayRuleApplicable,
    employmentStatus,
    additionalMatchSources,
    additionalDiscretionarySources,
    periodForCalculation,
    ...rest
  } = values;
  const intSourceCategory = parseInt(values[fields.sourceCategory], 10);
  console.log("intSourceCategory", intSourceCategory);
  const isDeferral =
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Deferral;
  const isEmployeeOther =
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.EmployeeOther;
  const isEmployerDiscretionary =
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Discretionary ||
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.NonElectiveRoth;
  const isEmployerMatch =
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Match ||
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.MatchRoth;
  const isEmployerOther =
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.EmployerOther;
  const isClientMode = values[fields.responsibleMode] == 1;
  const isPrevailingWages =
    intSourceCategory === SOURCE_CATEGORY_NAME_MAPPING.PrevailingWages;
  const isValidateMode = values[fields.responsibleMode] == 3;

  return {
    ...rest,
    sourceSubCategory: sourceSubCategory || undefined,
    ...(isDeferral && {
      employeeDeferralSource: {
        id: get(formValues, "employeeDeferralSource.id", 0),
        isContributionManatory,
        contributionType,
        limitMinimumDollar,
        limitMaximumDollar,
        maximumDollarCompensation,
        rehireDeferralPercentage,
        additionalDeferralSource,
      },
    }),
    ...(isEmployerDiscretionary &&
      !isClientMode && {
        employerDiscretionarySource: {
          id: get(formValues, "employerDiscretionarySource.id", 0),
          responsibleMode,
          eligiblePaymentType,
          employerContributionType : 
            isSafeHarbourMatch && safeHarbourType == 2
            ? 1 
            : employerContributionType,
          percentageOfCompensation:
            isSafeHarbourMatch && safeHarbourType == 2
            ? 3
            : percentageOfCompensation,
          isSafeHarbourMatch,
          safeHarbourType,
          isCalculationSuspended,
          isThresholdApplicable,
          isTrueUpApplicable,
          additionalDiscretionarySources,
          periodForCalculation,
          isMaximumLimitApplicable,
          maximumDollarLimit,
          isNonPayPeriodApplicable,
          isIncludeDefferals,
          isIncludePlanCompensation,
          isLastDayRule,
          isHoursRequirement,
          hours,
          isNormalRetirement,
          isEarlyRetirement,
          isDeath,
          isDisability,
        },
      }),

    ...(isEmployerMatch &&
      isClientMode && {
        employerMatchSource: {
          id: get(formValues, "employerMatchSource.id", 0),
          responsibleMode,
          sourceOfMatch: [
            ...transformToMultiselectSave(
              (values[fields.sourceOfMatch] || [])?.filter(
                (val) =>
                  !get(formValues, "employerMatchSource.sourceOfMatch", [])
                    .map((_) => _.sourceId)
                    .includes(val)
              ),
              "sourceId"
            ),
            ...synchronizeCollection(
              get(formValues, "employerMatchSource.sourceOfMatch", []),
              values[fields.sourceOfMatch],
              "sourceId"
            ),
          ],
          employerContributionType,
          isSafeHarbourMatch,
          safeHarbourType: getNumber(get(values, fields.safeHarbourType, 0)),
          percentageOfCompensation,
          percentageOfCalculation,
          enhancedshMatchPercentage,
          uptoPercentageOfDeferral,
          isNonPayPeriodApplicable,
          isIncludeDefferals,
          isIncludePlanCompensation,
          isLastDayRule,
          isHoursRequirement,
          hours,
          isNormalRetirement,
          isEarlyRetirement,
          isDeath,
          isDisability,
          firstTierMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? 100
              : parseInt(firstTierMatchPercent, 10),
          firstTierCompensationMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? safeHarbourType === 1
                ? 3
                : 1
              : parseInt(firstTierCompensationMatchPercent, 10),
          secondTierMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? 50
              : parseInt(secondTierMatchPercent, 10),
          secondTierCompensationMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? safeHarbourType === 1
                ? 2
                : 5
              : parseInt(secondTierCompensationMatchPercent, 10),
          thirdTierMatchPercent: isSafeHarbourMatch
            ? 0
            : parseInt(thirdTierMatchPercent, 10),
          thirdTierCompensationMatchPercent: isSafeHarbourMatch
            ? 0
            : parseInt(thirdTierCompensationMatchPercent, 10),
          isMaximumLimitApplicable,
          maximumDollarLimit,
        },
      }),
    ...(isEmployerDiscretionary &&
      isClientMode && {
        employerDiscretionarySource: {
          id: get(formValues, "employerDiscretionarySource.id", 0),
          responsibleMode,
          isSafeHarbourMatch,
          safeHarbourType,
          isMaximumLimitApplicable,
          maximumDollarLimit,
          employerContributionType : 
            isSafeHarbourMatch && safeHarbourType == 2
            ? 1 
            : employerContributionType,
          percentageOfCompensation:
            isSafeHarbourMatch && safeHarbourType == 2
            ? 3
            : percentageOfCompensation,
          isNonPayPeriodApplicable,
          isIncludeDefferals,
          isIncludePlanCompensation,
          isLastDayRule,
          isHoursRequirement,
          hours,
          isNormalRetirement,
          isEarlyRetirement,
          isDeath,
          isDisability,
        },
      }),
    ...(isEmployerMatch &&
      !isClientMode && {
        employerMatchSource: {
          id: get(formValues, "employerMatchSource.id", 0),
          responsibleMode,
          eligiblePaymentType,
          employerContributionType,
          periodForCalculation,
          sourceOfMatch: [
            ...transformToMultiselectSave(
              (values[fields.sourceOfMatch] || [])?.filter(
                (val) =>
                  !get(formValues, "employerMatchSource.sourceOfMatch", [])
                    .map((_) => _.sourceId)
                    .includes(val)
              ),
              "sourceId"
            ),
            ...synchronizeCollection(
              get(formValues, "employerMatchSource.sourceOfMatch", []),
              values[fields.sourceOfMatch],
              "sourceId"
            ),
          ],
          employmentStatus: [
            ...transformToMultiselectSave(
              (values[fields.employmentStatus] || [])?.filter(
                (val) =>
                  !get(
                    formValues.employerMatchSource,
                    fields.employmentStatus,
                    []
                  )
                    .map((_) => _.employmentStatusId)
                    .includes(val)
              ),
              "employmentStatusId"
            ),
            ...synchronizeCollection(
              get(formValues.employerMatchSource, fields.employmentStatus, []),
              values[fields.employmentStatus],
              "employmentStatusId"
            ),
          ].filter((x) => x != null),
          isSafeHarbourMatch,
          isCalculationSuspended,
          isThresholdApplicable,

          safeHarbourType: getNumber(get(values, fields.safeHarbourType, 0)),
          isCatchApplicable,
          enhancedshMatchPercentage,
          uptoPercentageOfDeferral,
          employerContributionType,
          percentageOfCompensation,
          isNonPayPeriodApplicable,
          isIncludeDefferals,
          isIncludePlanCompensation,
          isLastDayRule,
          isHoursRequirement,
          hours,
          isNormalRetirement,
          isEarlyRetirement,
          isDeath,
          isDisability,
          percentageOfCalculation,
          isLastDayRuleApplicable,
          firstTierMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? 100
              : parseInt(firstTierMatchPercent, 10),
          firstTierCompensationMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? safeHarbourType === 1
                ? 3
                : 1
              : parseInt(firstTierCompensationMatchPercent, 10),
          secondTierMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? 50
              : parseInt(secondTierMatchPercent, 10),
          secondTierCompensationMatchPercent:
            isSafeHarbourMatch && safeHarbourType !== 3
              ? safeHarbourType === 1
                ? 2
                : 5
              : parseInt(secondTierCompensationMatchPercent, 10),
          thirdTierMatchPercent: isSafeHarbourMatch
            ? 0
            : parseInt(thirdTierMatchPercent, 10),
          thirdTierCompensationMatchPercent: isSafeHarbourMatch
            ? 0
            : parseInt(thirdTierCompensationMatchPercent, 10),
          isTrueUpApplicable,
          additionalMatchSources,
          isMaximumLimitApplicable,
          maximumDollarLimit,
        },
      }),
    ...(isEmployerOther && {
      employerOtherSource: {
        id: get(formValues, "employerOtherSource.id", 0),
        qmacType: qmacType || qmacType,
        qmacAfterTaxDoller: get(values, "qmacAfterTaxDoller"),
        qmacDeferralDoller: get(values, "qmacDeferralDoller"),
        qmacAfterTaxPercentage: get(values, "qmacAfterTaxPercentage"),
        qmacDeferrlPercentage: get(values, "qmacDeferrlPercentage"),
        isMaximumLimitApplicable,
        maximumDollarLimit,
      },
    }),
    ...(isPrevailingWages && {
      employerOtherSource: {
        isMaximumLimitApplicable,
        maximumDollarLimit,
      },
    }),
    ...(!intSourceCategory &&
      values[fields.sourceType] == 2 && {
        employerDiscretionarySource: {
          id: 0,
          isMaximumLimitApplicable,
          maximumDollarLimit,
          isNonPayPeriodApplicable,
          isIncludeDefferals,
          isIncludePlanCompensation,
          isLastDayRule,
          isHoursRequirement,
          hours,
          isNormalRetirement,
          isEarlyRetirement,
          isDeath,
          isDisability,
        },
      }),
    id: get(rest, "id", undefined),
    effectiveStartDate: get(rest, "effectiveStartDate", null),
    effectiveEndDate: get(rest, "effectiveEndDate", null),
  };
};
